import * as config from "Config";
import * as constants from "./constants";


export function clearStore(newObject) {
  return {
    type: constants.TAG_LIST_CLEAR_STORE
  };
}

export function initListData(params) {
  let url = config.apiUrl + "/api/Tag";
  if (params.companyId) {
    url += "/Company/" + params.companyId + "/Summury";
  }
  if (params.companyGroupId) {
    url += "/CompanyGroup/" + params.companyGroupId + "/Summury";
  }

  return {
    remote: {
      method: "get",
      url
    },
    actions: [
      constants.TAG_LIST_SUMMURY_LOAD_START,
      constants.TAG_LIST_SUMMURY_LOAD_SUCCESS,
      constants.TAG_LIST_SUMMURY_LOAD_FAIL,
    ]
  };
}

export function deleteTag(params) {
  let url = config.apiUrl + "/api/Tag/" + params.id;
  if (params.companyId) {
    url += "/Company/" + params.companyId;
  }
  if (params.companyGroupId) {
    url += "/CompanyGroup/" + params.companyGroupId;
  }

  return {
    remote: {
      method: "delete",
      url
    },
    actions: [
      constants.TAG_LIST_REMOVE_START,
      constants.TAG_LIST_REMOVE_SUCCESS,
      constants.TAG_LIST_REMOVE_FAIL,
    ]
  };
}
